import { darkColorTokens, lightColorTokens } from "@carbon6/c6-frontend-design";
import type { StatusTokens } from "@carbon6/c6-frontend-design";
import { useThemeModePreference } from "@/app/theme";

/**
 * 현재 테마의 c6 status 토큰 묶음. 앱이 status 색을 JS 로 읽는 유일한 이유가 있다.
 * c6 `LabelChip` 이 CSS 변수가 아니라 RGB 정수를 받기 때문이다. CSS 로 칠할 수 있는 표면은
 * 계속 status CSS 변수를 쓴다.
 *
 * 테마는 c6 ThemeProvider 에 전달하는 것과 같은 앱 스토어에서 읽는다. 그래서 두 값이 달라질 수 없다.
 * styled-components `useTheme` 을 쓰면 ThemeProvider 없이 렌더하는 dom 테스트가 모두
 * provider 를 요구하게 된다.
 */
export function useStatusTokens(): StatusTokens {
  const [themeMode] = useThemeModePreference();
  return themeMode === "dark" ? darkColorTokens.status : lightColorTokens.status;
}

/**
 * status 토큰 값을 `LabelChip color` 가 받는 RGB 정수로 바꾼다. 램프 값은 모두 `#rrggbb` 다
 * (c6 `palette.ts`). 형식이 다르면 검정으로 바꾸지 않고 예외를 던진다. 그래서 c6 가 표현을
 * 바꾸면 바로 알 수 있다.
 */
export function statusChipColor(value: string): number {
  const match = /^#([0-9a-f]{6})$/i.exec(value);
  if (match === null) {
    throw new Error(`Unexpected status token format: ${value}`);
  }
  return Number.parseInt(match[1], 16);
}
